<template>
    <div class="home">
        <b-container v-if="outlet">
            <div class="text-title">
                <b-button to="/" variant="outline-primary" class="cst-button--small">
                <div class="cst-button__wrapper cst-button__icon cst-button__icon--left">
                    <!-- <img src="../assets/Left@2x.png" alt="">  -->
                    <b>{{ outlet.outlet_status }} {{ outlet.name }}</b>
                </div>
                </b-button>
                <div class="divider divider--margin-small"></div>
                <p>Kepuasan Anda, semangat bagi kami untuk berikan yang terbaik.<br/>Bagikan pengalaman Anda terhadap petugas kami.</p>
            </div>
            <div class="divider divider--margin-small"></div>
            <div class="cst-tabs">
                <div class="cst-list" v-if="categories">
                    <div class="cst-list__block" v-for="(category,index) in categories" :key="index">
                        <router-link :to="'/home/'+outlet.code+'/'+category.id+'/'+(category.is_facility ? 'facilities' : 'employees')" class="profile-card profile-card--shadow profile-card--2">
                            <div class="profile-card__image profile-card__image--2">
                                <div class="inner" :style="{ backgroundImage: 'url(\'' + category.image + '\')' }">
                                </div>
                            </div>
                            <div class="profile-card__content">
                                <h1>{{ category.name }}</h1>
                            </div>
                        </router-link>
                        <!-- <router-link v-else to="/home" class="profile-card profile-card--shadow profile-card--2">
                            <div class="profile-card__image profile-card__image--2">
                                <div class="inner" :style="{ backgroundImage: 'url(' + category.image + ')' }">
                                </div>
                            </div>
                            <div class="profile-card__content">
                                <h1>{{ category.name }}</h1>
                            </div>
                        </router-link> -->
                    </div>
                </div>
                <div class="cst-list" v-else>
                    Loading data...
                </div>

                <div class="divider divider--margin-small"></div>
                <div class="divider divider--margin-small mobile-small-hide"></div>

                <div class="btn-layout-float">
                <b-row align-v="center">
                    <b-col md="7" lg="7" xl="7" class="text-right-2 mobile-small-text-center">
                    <b-button v-if="ratings" @click="showSummaryModal" variant="warning" class="cst-button">
                        <div class="cst-button__wrapper cst-button__icon cst-button__icon--right">
                        Kirim Penilaian <img src="../assets/Right@2x.png" alt="">
                        </div>
                    </b-button>
                    </b-col>
                </b-row>
                </div>
                <div class="divider mobile-small-show"></div>
                <div class="divider mobile-small-show"></div>
                <div class="divider mobile-small-show"></div>
            </div>
        </b-container>
    

        <b-modal ref="summaryModal" scrollable size="xl modal-fs">
            <div>
                <b-row>
                    <b-col sm="12" md="3" lg="3" xl="3" v-for="(item, i) in ratings" :key="i">
                        <div class="summary-card" v-if="item.is_facility == 1">
                            <div class="summary-card__title">
                                <div class="summary-card__image">
                                <div class="inner" :style="{ backgroundImage: 'url(\'' + item.rating[0].aspect_image + '\')', backgroundPosition: 'center' }"></div>
                                </div>
                                <div class="summary-card__name">
                                <h5>{{ item.rating[0].aspect_name }}</h5>
                                <!-- <p>{{ erating.role }} - {{ erating.npp }}</p> -->
                                </div>
                            </div>
                            <b-row>
                                <b-col cols="6">
                                    <div class="summary-card__penilaian">
                                        <!-- <p>{{ i+1 === erating.rating.length ? 'Komentar' : rate.aspect_name }}</p> -->
                                        <div class="rate-animation rate-animation--2">
                                        <div class="svg-hide">
                                            <svg data-v-59a74259="" id="icon-star-full" viewBox="0 0 32 32"><title data-v-59a74259="">star-full</title> <path data-v-59a74259="" d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"></path></svg>
                                        </div>
                                        <!-- <p v-if="i+1 === erating.rating.length"><strong>{{ erating.notes }}</strong></p> -->
                                        <ul class="rate-animation__list">
                                            <li>
                                            <svg :class="item.rating[0].rate >= 1 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                            </li>
                                            <li>
                                            <svg :class="item.rating[0].rate >= 2 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                            </li>
                                            <li>
                                            <svg :class="item.rating[0].rate >= 3 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                            </li>
                                            <li>
                                            <svg :class="item.rating[0].rate >= 4 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                            </li>
                                            <li>
                                            <svg :class="item.rating[0].rate === 5 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                            </li>
                                        </ul>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                        <div class="summary-card" v-else>
                            <div class="summary-card__title">
                                <div class="summary-card__image">
                                <div class="inner" :style="{ backgroundImage: 'url(\'' + item.image + '\')', backgroundPosition: 'center' }"></div>
                                </div>
                                <div class="summary-card__name">
                                <h5>{{ item.name }}</h5>
                                <!-- <p>{{ item.position_name }} - {{ item.npp }}</p> -->
                                <p>{{ item.position_name }}</p>
                                </div>
                            </div>
                            <b-row>
                                <b-col cols="6" v-for="(itemx, i) in item.rating" :key="i">
                                <div class="summary-card__penilaian">
                                    <p>{{ itemx.aspect_name }}</p>
                                    <div class="rate-animation rate-animation--2">
                                    <div class="svg-hide">
                                        <svg data-v-59a74259="" id="icon-star-full" viewBox="0 0 32 32"><title data-v-59a74259="">star-full</title> <path data-v-59a74259="" d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"></path></svg>
                                    </div>
                                    <p v-if="itemx.type == 'TEXT'"><strong>{{ itemx.note }}</strong></p>
                                    <ul class="rate-animation__list" v-else>
                                        <li>
                                        <svg :class="itemx.rate >= 1 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                        </li>
                                        <li>
                                        <svg :class="itemx.rate >= 2 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                        </li>
                                        <li>
                                        <svg :class="itemx.rate >= 3 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                        </li>
                                        <li>
                                        <svg :class="itemx.rate >= 4 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                        </li>
                                        <li>
                                        <svg :class="itemx.rate === 5 ? 'icon' : 'icon off'"><use xlink:href="#icon-star-full"></use></svg>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <template slot="modal-header">
                <div class="d-block text-center" style="width:100%">
                <div class="text-title text-title--sub">
                    <h2>Penilaian Anda siap dikirim</h2>
                    <p>Berikut adalah penilaian dari Anda yang siap dikirimkan.</p>
                </div>
                </div>
            </template>
            <template slot="modal-footer" >
                <b-row class="btn-mf-row">
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-button @click="showBatalModal" block variant="outline-danger" class="cst-button">
                    <div class="cst-button__wrapper ">
                        Batalkan Penilaian
                    </div>
                    </b-button>
                    <div class="divider divider--margin-small mobile-small-show"></div>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-button @click="hideSummaryModal" block variant="outline-primary" class="cst-button">
                    <div class="cst-button__wrapper ">
                        Rating Aspek Lainnya
                    </div>
                    </b-button>
                    <div class="divider divider--margin-small mobile-small-show"></div>
                </b-col>
                <b-col sm="12" md="4" lg="4" xl="4">
                    <b-button @click="simpanPenilaian()" block variant="warning" class="cst-button" id="simpanBtn">
                    <div class="cst-button__wrapper" id="isiSimpanBtn">
                        Kirim Penilaian
                    </div>
                    </b-button>
                </b-col>
                </b-row>
            </template>

        </b-modal>

        <b-modal ref="batalModal" hide-header hide-footer>
            <div class="d-block text-center">
                <div class="text-title text-title--sub">
                <h2>Batalkan Penilaian</h2>
                <p>Semua penilaian Anda sebelumnya akan hilang.<br/>Apakah Anda yakin ingin membatalkan penilaian?</p>
                </div>
            </div>
            <div class="divider"></div>
            <b-row>
                <b-col>
                <b-button @click="batalPenilaian" block variant="outline-danger" class="cst-button">
                    <div class="cst-button__wrapper">
                    Ya
                    </div>
                </b-button>
                </b-col>
                <b-col>
                <b-button @click="hideBatalModal" block variant="warning" class="cst-button">
                    <div class="cst-button__wrapper">
                    Tidak
                    </div>
                </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="successModal" hide-header hide-footer @hidden="hideSuccessModal">
            <div class="d-block text-center">
                <div class="text-title text-title--sub">
                <h2>Penilaian Dikirim</h2>
                <p>Terima kasih! Penilaian Anda telah berhasil kami kirim.</p>
                </div>
            </div>
            <div class="divider"></div>
            <b-row>
                <b-col>
                <b-button @click="hideSuccessModal" block variant="warning" class="cst-button">
                    <div class="cst-button__wrapper">
                    Tutup
                    </div>
                </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="failedModal" hide-header hide-footer @hidden="hideFailedModal">
            <div class="d-block text-center">
                <div class="text-title text-title--sub">
                <h2>Penilaian Gagal Dikirim</h2>
                <p v-html="failedText"></p>
                </div>
            </div>
            <div class="divider"></div>
            <b-row>
                <b-col>
                <b-button @click="hideFailedModal" block variant="warning" class="cst-button">
                    <div class="cst-button__wrapper">
                    Tutup
                    </div>
                </b-button>
                </b-col>
            </b-row>
        </b-modal>

  </div>
</template>

<script>
    import storage from '@/storage'
    import api from '@/api/outlets'
    import rate from '@/api/rate'
    import categories from '@/api/categories'
    export default {
        name: 'home',
        data() {
            return {
                ratings: null,
                outlet: null,
                categories: null,
                hasResult: false,
                loadingText: '',
                failedText: '',
                params: {
                    q:'',
                    page: 1
                }
            }
        },
        mounted () {
            this.getOutlet();
            this.getCategories();
            this.ratings = storage.get()
            if(this.ratings) {
                this.$refs['summaryModal'].show()
            }
        },
        methods: {
            getOutlet() {
                var self = this
                this.loadingText = 'Loading...'
                api.getOutlet(this.$route.params.id)
                .then(function (response) {
                    // handle success
                    self.hasResult = true
                    self.outlet = response.data.data
                })
                .catch(function (error) {
                    console.log(error);
                    self.loadingText= 'Outlet tidak ditemukan'
                    self.hasResult = false
                    self.$router.push(`/`)
                })
            },
            getCategories() {
                var self = this
                this.loadingText = 'Loading...'
                categories.get()
                .then(function (response) {
                    // handle success
                    self.hasResult = true
                    self.categories = response.data.data
                })
                .catch(function (error) {
                    console.log(error);
                    self.loadingText= 'Outlet tidak ditemukan'
                    self.hasResult = false
                })
            },
            showSummaryModal() {
                this.$refs['summaryModal'].show()
            },
            hideSummaryModal() {
                this.$refs['summaryModal'].hide()
            },
            showBatalModal() {
                this.$refs['batalModal'].show()
            },
            hideBatalModal() {
                this.$refs['batalModal'].hide()
            },
            showSuccessModal() {
                this.$refs['successModal'].show()
                this.$refs['summaryModal'].hide()
            },
            hideSuccessModal() {
                this.$refs['successModal'].hide()
                location.reload()
            },
            showFailedModal() {
                this.$refs['failedModal'].show()
                this.$refs['summaryModal'].hide()
            },
            hideFailedModal() {
                this.$refs['summaryModal'].hide()
                this.$refs['failedModal'].hide()
            },
            batalPenilaian() {
                console.log('batalkan')
                this.$refs['summaryModal'].hide()
                this.$refs['batalModal'].hide()
                storage.clearData()
                location.reload()
            },
            simpanPenilaian() {
                //send to server side
                var self = this
                var params = {
                    sessionCode: storage.getVisitor().sessionCode,
                    data: storage.get()
                }
                console.log(params)
                rate.rate(params)
                .then(function (response) {
                    // handle success
                    console.log(response)
                    storage.clearData()
                    self.showSuccessModal();
                })
                .catch(function (error) {
                    console.log(error);
                    self.failedText = error.response.data.message
                    self.showFailedModal()
                })
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>